import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { useFormikContext } from 'formik';
import { Label } from 'core/components/label';

const OfferUpdated = ({ classes }) => {
  const { values, resetForm } = useFormikContext();
  useEffect(() => {
    resetForm(values);
  }, []);
  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        Offer Updated
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        Send it to member or copy link to see it in a new tab
      </Label>
      <Grid container alignItems="center" className={classes.bottom} />
    </>
  );
};

OfferUpdated.propTypes = {
  classes: PropTypes.object.isRequired
};

export default OfferUpdated;
